module.exports = __webpack_public_path__ + "static/media/light-theme-distance.77e94d24.svg";